(function() {

  em.gridTabs = {};

  em.gridTabs.init = function() {
    var tabs = document.querySelectorAll('.the-grid-tabs [role="tab"]');

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        tabs.forEach(function(t) { t.setAttribute('aria-selected', 'false'); });
        tab.setAttribute('aria-selected', 'true');

        var tabIndex = tab.getAttribute('for').replace('tab-', '');
        em.gridTabs.showSubtabRow(tabIndex);
      });
    });

    document.querySelectorAll('.the-grid-subtabs__btn').forEach(function(btn) {
      btn.addEventListener('click', em.gridTabs.changeSubTab);
    });
  };

  em.gridTabs.showSubtabRow = function(tabIndex) {
    document.querySelectorAll('.the-grid-tabs__subtab-row').forEach(function(row) {
      row.classList.remove('is-visible');
    });
    var activeRow = document.querySelector('.the-grid-tabs__subtab-row[data-parent-tab="' + tabIndex + '"]');
    if (activeRow) { activeRow.classList.add('is-visible'); }
  };

  em.gridTabs.changeSubTab = function(e) {
    var btn = e.currentTarget;
    var subtabId = btn.getAttribute('data-subtab');
    var row = btn.closest('.the-grid-tabs__subtab-row');
    var parentIndex = row ? row.getAttribute('data-parent-tab') : null;

    if (row) {
      row.querySelectorAll('.the-grid-subtabs__btn').forEach(function(b) {
        b.classList.remove('is-active');
      });
    }

    if (parentIndex !== null) {
      var contentPanel = document.getElementById('tab-content-' + parentIndex);
      if (contentPanel) {
        contentPanel.querySelectorAll('.the-grid-subtabs__panel').forEach(function(p) {
          p.classList.remove('is-active');
        });
      }
    }

    btn.classList.add('is-active');
    var panel = document.getElementById(subtabId);
    if (panel) { panel.classList.add('is-active'); }
  };

})();
